import { render, staticRenderFns } from "./FakeSelect.vue?vue&type=template&id=0c9beb76&"
import script from "./FakeSelect.vue?vue&type=script&lang=js&"
export * from "./FakeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports